/** Must match CHANNEL_NAME / MESSAGE_TYPE in src/assets/ivr-search-handoff.html */
export const IVR_SEARCH_HANDOFF_CHANNEL_NAME = 'newleaf-crm-ivr-search-handoff';
export const IVR_SEARCH_HANDOFF_MESSAGE_TYPE = 'IVR_SEARCH_HANDOFF';
